import { Property } from "csstype";
import React, { PropsWithChildren } from "react";
import styles from "./styles.module.css";

export const Card: React.FC<PropsWithChildren<{ className?: string }>> = ({
  children,
  className,
}) => {
  return (
    <article className={`${styles.Card} ${className}`}>{children}</article>
  );
};

export const CardTitle: React.FC<
  PropsWithChildren<{
    align?: Property.TextAlign;
    className?: string;
  }>
> = ({ children, align, className }) => {
  return (
    <h1
      className={styles.CardTitle + " " + className}
      style={{
        textAlign: align,
      }}
    >
      {children}
    </h1>
  );
};

export const CardSubtitle: React.FC<
  PropsWithChildren<{
    align?: Property.TextAlign;
  }>
> = ({ children, align }) => {
  return (
    <h2
      className={styles.CardSubtitle}
      style={{
        textAlign: align,
      }}
    >
      {children}
    </h2>
  );
};
